import { useState } from 'react';
import styles from './RoleCard.module.css';
import ChallengeSubmissionForm from './ChallengeSubmissionForm'; 

export default function RoleCard({ role }) {
  const [isExpanded, setIsExpanded] = useState(false);
  const [showForm, setShowForm] = useState(false); 

  const handleSubmit = (challengeId, formData) => {
    console.log('Submitting:', challengeId, formData);
    alert(`Challenge for "${role.title}" submitted successfully!`);
    setShowForm(false);
  };

  return (
    <section id='opportunities'>
      <div className={`${styles.roleCard} ${isExpanded ? styles.expanded : ''}`}>
        <div 
          className={styles.roleHeader}
          onClick={() => setIsExpanded(!isExpanded)}
        >
          <div className={styles.roleTitleContainer}>
            <h3 className={styles.roleTitle}>{role.title}</h3>
            <div className={styles.roleMeta}>
              <span className={styles.roleLocation}>{role.location}</span>
              <span className={styles.roleType}>{role.type}</span>
            </div>
          </div>
          <div className={styles.expandIcon}>
            {isExpanded ? '−' : '+'}
          </div>
        </div>
        
        {isExpanded && (
          <div className={styles.roleContent}>
            <div className={styles.roleOverview}>
              <h4>Role Overview</h4>
              <p>{role.overview}</p>
            </div>
            
            {role.responsibilities && (
              <div className={styles.roleSection}>
                <h4>Key Responsibilities</h4>
                <ul>
                  {role.responsibilities.map((item, index) => (
                    <li key={index}>{item}</li>
                  ))}
                </ul>
              </div>
            )}
            
            {role.qualifications && (
              <div className={styles.roleSection}>
                <h4>Qualifications</h4>
                <ul>
                  {role.qualifications.map((item, index) => (
                    <li key={index}>{item}</li>
                  ))}
                </ul>
              </div>
            )}
            
            <div className={styles.ctaContainer}>
              <button 
                className={styles.challengeButton}
                onClick={() => setShowForm(true)} 
              >
                Take Challenge
              </button>
            </div>
          </div>
        )}
      </div>

      
      {showForm && (
        <ChallengeSubmissionForm 
          challenge={role}
          onClose={() => setShowForm(false)}
          onSubmit={handleSubmit}
        />
      )}
    </section>
  );
}
